<template>
  <basic-modal @hide="close"
               v-model="opened"
               aria-label="Wiki Editor Name"
               role="dialog">
      <div slot="header">
          <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
          <h3 class="modal-title">Wiki Editing</h3>
      </div>

      <div class="row">
          <div class="col-sm-12">
             <alert type="info">
                 If somebody is supporting you to edit this Wiki, please confirm who is helping
             </alert>
          </div>
      </div>

      <div class="row">
          <div class="col-sm-12">
              <div>
                  <input autocomplete="off" id="input-fn" class="form-control" type="text" placeholder="Someone from my Circle is helping me (select user)">
                  <typeahead v-model="wikiEditor"  class="user-selector-input" target="#input-fn" :data="fullNameCircleMembers" item-key="fullName"/>
              </div>
          </div>
      </div>

      <div class="row margin-15-top">
          <div class="col-sm-12">
              <div>
                  <input id="fullname"
                         class="form-control"
                         type="text"
                         placeholder="Someone else is helping me (add the person’s full name here)"
                         :disabled="!!wikiEditorId"
                         v-model="wikiEditorName"
                         autocomplete="name"
                  >
              </div>
          </div>
      </div>

      <div class="row margin-15-top">
          <div class="col-sm-12">
              <div>
                  <btn
                          block
                          size="lg"
                          type="primary"
                          class="current-user-button"
                          :disabled="!!wikiEditorName"
                          @click="chooseCurrentUser()"
                  >
                      <img :src="avatarUrl" alt="User avatar" class="avatar">
                      No, it’s just me doing it on my own ({{ userReadableName }})
                  </btn>
              </div>
          </div>
      </div>

      <div slot="footer">
          <button class="btn btn-mm btn-green"
                  :disabled="!wikiEditorId && !wikiEditorName"
                  @click="saveChanges">
              Continue editing
          </button>
      </div>
  </basic-modal>
</template>

<script>
    import PopupPromiseMixin from "~/vue/mixins/PopupPromiseMixin";
    import BasicModal from "~/vue/common_components/BasicModal.vue";
    import BasicModalCloseButton from "~/vue/common_components/BasicModalCloseButton.vue";
    import {CurrentUserClass} from "~/angular/app/shared/CurrentUser";
    import WikiResource from "~/angular/app/wiki/wiki_main_resource";

export default {
    name: "WikiEditorNamePopup",
    components: {BasicModalCloseButton, BasicModal},
    mixins: [PopupPromiseMixin],
    data() {
        return {
            search: "",
            wikiEditor: undefined,
            wikiEditorId: undefined,
            wikiEditorName: undefined,
            usersCircleMembers: [],
            wikiId: undefined,
        };
    },
    computed: {
        fullNameCircleMembers() {
            return this.usersCircleMembers.map((member) => ({
                ...member,
                fullName: `${member.name.toLowerCase()} ${member.username.toLowerCase()}`
            }));
        },
        avatarUrl() {
            const cu = new CurrentUserClass();
            return cu.avatar;
        },
        userReadableName() {
            const cu = new CurrentUserClass();
            return `${cu?.first_name} ${cu?.last_name}`;
        },
    },
    watch: {
        wikiEditor(newVal) {
            this.wikiEditorId = newVal.id;
        }
    },
    methods: {
        async showedHook(){
            try {
                const res = await WikiResource().get_potential_editors(this.wikiId);
                this.usersCircleMembers = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        setInitial(wikiId) {
            this.wikiId = wikiId;
        },
        async saveChanges() {
            const data = {};
            if (this.wikiEditorId) {
                const cu = new CurrentUserClass();
                data.id = this.wikiEditorId;
                if (this.wikiEditorId === cu.id) {
                    data.name = this.userReadableName;
                    data.isMe = true;
                } else {
                    data.name = this.usersCircleMembers.filter((member) => member.id === this.wikiEditorId)[0].name;
                    data.isMe = false;
                }
            } else {
                data.id = null;
                data.name = this.wikiEditorName;
                data.isMe = false;
            }
            this.save(data);
        },
        chooseCurrentUser() {
            const cu = new CurrentUserClass();
            this.wikiEditorId = cu.id;
            this.saveChanges();
        },
    },
};
</script>

<style scoped>
    .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
    }

    .user-selector-input{
        &::v-deep(.dropdown-menu){
            width: 100%;
        }
    }

    .current-user-button {
        text-align: start;
    }
</style>
